import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import { ChevronLeft, ChevronRight, Payment, Send } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import { _get, _post } from "../Api";
import { FormattedMessage } from "react-intl";
import GetCurrency from "../helper/GetCurrency";
import { useParams } from "react-router-dom";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import { parse } from "date-fns";
import withIntl from "../utils/withIntl";
import AuthorizationWrapper from "../components/AuthorizationWrapper";
import { Tooltip } from "@material-ui/core";
import RefundDialog from "../components/Refund/RefundDialog";
import { useDialog } from "../components/Dialogs/DialogProvider";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {},
  column: {
    flexBasis: "20%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  hide: {
    [theme.breakpoints.down("sm")]: {
      visibility: "hidden",
    },
  },
  div: {
    borderLeft: "1px solid",
    paddingLeft: "20px",
    [theme.breakpoints.down("sm")]: {
      borderLeft: "none",
      paddingLeft: 0,
    },
  },
}));

const processData = (data, callback) => {
  let result = data.map((row) => {
    let pickupTime;
    if (row.pickup_timestamp === 0) {
      pickupTime = "Zo snel mogelijk";
    } else {
      let date = new Date(row.pickup_timestamp * 1000);
      pickupTime = date.toLocaleTimeString() + " " + date.toLocaleDateString();
    }
    let address = null;
    let name = null;
    let contactInfo = [];
    try {
      let temp = JSON.parse(row.contact_information);
      address = temp["address"];
      name = temp["name"];
      if (temp) {
        Object.keys(temp).forEach((item) => {
          if (temp[item].length > 0) {
            if (item === "address") {
              contactInfo.push("Adres: " + temp[item]);
            } else if (item === "postalCode") {
              contactInfo.push("Postcode: " + temp[item]);
            } else if (item === "city") {
              contactInfo.push("Stad: " + temp[item]);
            } else if (item === "name") {
              contactInfo.push("Naam: " + temp[item]);
            } else if (item === "email") {
              contactInfo.push("Email: " + temp[item]);
            } else if (item === "phone") {
              contactInfo.push("Telefoon: " + temp[item]);
            }
          }
        });
      }
    } catch (e) {
      // Error if not string --> not parsable
    }

    let orders = [];
    row.ordergroup.o_m_articles.forEach((omarticle, i) => {
      orders.push({
        name: omarticle.name,
        cost: omarticle.price,
        totalCost: omarticle.total_cost,
        amount: omarticle.amount,
        modifiers: [],
        remark: omarticle.info?.remark,
      });
      omarticle.o_m_modifiergroups.forEach((ommodifiergroup) => {
        ommodifiergroup.o_m_modifierarticles.forEach((ommodifierarticle) => {
          orders[i].modifiers.push({
            name: ommodifierarticle.name,
            cost: ommodifierarticle.price,
            amount: ommodifierarticle.amount,
          });
        });
      });
    });
    if (row.extra_delivery_costs && row.extra_delivery_costs > 0) {
      orders.push({
        name: "Bezorgkosten",
        cost: row.extra_delivery_costs,
        amount: "",
      });
    }
    if (row.extra_payment_costs && row.extra_payment_costs > 0) {
      orders.push({
        name: "Betaalkosten",
        cost: row.extra_payment_costs,
        amount: "",
      });
    }

    if (row.status === "FINISHED") {
      row.status = "Afgerond";
    } else if (row.status === "ORDERED") {
      row.status = "In behandeling";
    } else if (row.status === "SCHEDULED") {
      row.status = "Scheduled for " + new Date(row.order_on_timestamp * 1000).toLocaleString();
    } else if (row.status === "PAID" || row.status === "ORDERING") {
      row.status = "Nog niet geaccepteerd door POS";
    }

    if (row.receipt_type === "TAKEAWAY") {
      row.receipt_type = "Afhalen";
    } else if (row.receipt_type === "DELIVERY") {
      row.receipt_type = "Bezorgen";
    }
    if (row.payment_method === "CASH") {
      row.payment_method = "Contant";
    } else if (row.payment_method === "CARD") {
      row.payment_method = "Pinnen";
    } else if (row.payment_method === "IDEAL") {
      row.payment_method = "iDeal";
    } else if (row.payment_method === "option_at_pickup") {
      row.payment_method = "Bij afhaal";
    } else if (row.payment_method == null) {
      row.payment_method = "?";
    }

    let date = parse(row.created_at + "Z", "yyyy-MM-dd HH:mm:ssX", new Date());
    return {
      id: row.id,
      amount_refunded: row.amount_refunded,
      paymentMethod: row.payment_method,
      created: date.toLocaleString(),
      remark: row.remark,
      number: row.receipt_number || row.number,
      contactInfo,
      pickupTime: pickupTime,
      status: row.status,
      orderType: row.type,
      pickupType: row.receipt_type,
      address: address,
      name: name,
      cost:
        (row.total_cost + row.extra_delivery_costs + row.extra_payment_costs + (row.ordergroup.tip_amount ?? 0)) / 100,
      ordersCount: row.ordergroup.o_m_articles.reduce((a, b) => a + (b["amount"] || 0), 0),
      orders: orders,
      tableId: row.table_id,
      tipAmount: (row.ordergroup.tip_amount ?? 0) / 100.0,
    };
  });
  callback(result);
};

const fetchData = (id, page, perPage, callback) => {
  _get("/nova/ta_merchant/" + id + "/ta_receipt?number_per_page=" + perPage + "&page=" + page)
    .then((res) => {
      processData(res.data, callback);
    })
    .catch((e) => {
      swal({
        title: "Oops!",
        text: "Something went wrong.",
        icon: "error",
      });
      callback(null, e);
    });
};

function TakeawayDeliveryOrders() {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [orders, setOrders] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [perPage, setPerPage] = React.useState(localStorage.getItem("ordersPerPage") || 10);
  const [expanded, setExpanded] = React.useState([]);
  const [isTables, setIsTables] = React.useState(false);
  const [taMerchant, setTaMerchant] = React.useState(null);
  const taMerchantId = Number.parseInt(useParams().taMerchantId);
  const [openDialog] = useDialog();

  useEffect(() => {
    const onChange = () => {
      setTaMerchant(cloudStore.merchant.ta_merchants.find((taMerchant) => taMerchant.id === taMerchantId));
    };

    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChange);
  }, [setTaMerchant, taMerchantId]);

  if (!taMerchant) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (loading) {
    fetchData(taMerchantId, page, perPage, (res, e) => {
      if (e) {
        localStorage.setItem("ordersPerPage", 10);
        setPerPage(10);
      } else {
        _get("/nova/ta_merchant/" + taMerchantId)
          .then((result) => {
            if (result.data.sp_qr_codes && result.data.sp_qr_codes[0]) {
              console.log("Setting webapplink");
              localStorage.setItem("webAppLink", result.data.sp_qr_codes[0].identifier);
            }
            if (result.data.is_tables === 1) {
              setIsTables(true);
            }
          })
          .catch((e) => {
            swal({
              title: "Oops!",
              text: "Something went wrong.",
              icon: "error",
            });
            console.log(e);
          });
        setLoading(false);
        setOrders(res);
      }
    });
  }

  const handleExpansion = (id) => {
    let arr = expanded;
    if (expanded.includes(id)) {
      let index = expanded.indexOf(id);
      arr.splice(index, 1);
      setExpanded([...arr]);
    } else {
      arr.push(id);
      setExpanded([...arr]);
    }
  };

  const fetchNextPage = () => {
    setPage(page + 1);
    setLoading(true);
  };

  const fetchPreviousPage = () => {
    if (page > 0) {
      setPage(page - 1);
      setLoading(true);
    }
  };

  const handleExpandAll = () => {
    let arr = [];
    for (let i = 0; i < orders.length; i++) {
      arr.push(i);
    }
    setExpanded([...arr]);
  };

  const handleCollapseAll = () => {
    setExpanded([]);
  };

  const handleItemsPerPage = (event) => {
    setPage(0);
    setPerPage(event.target.value);
    localStorage.setItem("ordersPerPage", event.target.value);
    setLoading(true);
  };

  if (loading) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h4">Takeaway & Delivery Orders - {cloudStore.merchant.name}</Typography>
        <div style={{ margin: "15px" }}>
          <Button onClick={handleExpandAll} style={{ marginRight: "5px" }} variant="outlined">
            <FormattedMessage id={"expand_all"} />
          </Button>
          <Button onClick={handleCollapseAll} variant="outlined">
            <FormattedMessage id={"collapse_all"} />
          </Button>
        </div>
      </div>
      <Divider style={{ marginBottom: "10px" }} />
      <div>
        {orders.map((order, i) => {
          return (
            <div style={{ marginBottom: "10px" }}>
              <Accordion
                expanded={expanded.includes(i)}
                defaultExpanded={false}
                variant="outlined"
                onChange={() => handleExpansion(i)}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1c-content" id="panel1c-header">
                  <Grid container direction="row" spacing={2}>
                    <Grid item lg={1}>
                      <Typography className={classes.heading} color="primary">
                        {isTables ? order.tableId + ", T" + order.number : "T" + order.number}
                      </Typography>
                    </Grid>
                    <Grid item lg={2} md={0} sm={0} xs={0} className={classes.hide}>
                      <Typography className={classes.heading}>{order.created}</Typography>
                    </Grid>
                    <Grid item lg={2}>
                      <Typography className={classes.heading}>
                        {order.pickupType === "Afhalen" ? order.name : order.address}
                      </Typography>
                    </Grid>
                    <Grid item lg={1} md={6} sm={6} xs={6}>
                      <Typography
                        className={classes.secondaryHeading}
                        style={{
                          color: order.status === "Afgerond" ? "grey" : "red",
                        }}
                      >
                        {order.status}
                      </Typography>
                    </Grid>
                    <Grid item lg={2} md={0} sm={0} xs={0} className={classes.hide}>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        {order.pickupType === "Afhalen" ? <LocalMallIcon /> : <DirectionsBikeIcon />}
                        <Typography style={{ marginLeft: "5px" }} className={classes.secondaryHeading}>
                          {order.pickupType}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item lg={2} xs={0} className={classes.hide}>
                      <Typography className={clsx(classes.secondaryHeading, classes.hide)}>
                        {order.ordersCount} item(s)
                      </Typography>
                    </Grid>
                    <Grid item lg={2}>
                      <Typography className={classes.secondaryHeading}>
                        {GetCurrency()} {order.cost.toFixed(2)} ({order.paymentMethod})
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container xs={12}>
                    <Grid item container lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: 20 }} direction="column">
                      <div>
                        <Typography variant="caption">
                          Bestelling {order.pickupType === "Afhalen" ? "afhalen" : "bezorgen"}
                          {order.pickupTime === "Zo snel mogelijk"
                            ? ": " + order.pickupTime.toLowerCase()
                            : " om " + order.pickupTime}
                        </Typography>
                        <br />
                        {order.contactInfo.map((field) => {
                          return (
                            <div>
                              <Typography variant="caption">{field}</Typography>
                              <br />
                            </div>
                          );
                        })}
                      </div>

                      <br />
                      <div>
                        {order.remark ? <Typography variant="caption">Opmerking: {order.remark}</Typography> : null}
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AuthorizationWrapper
                          permission={"takeaway.resend_order"}
                          child={
                            <Tooltip title={"Resend order to POS"}>
                              <IconButton
                                onClick={() => {
                                  _post("/nova/ta_merchant/" + taMerchantId + "/ta_receipt/" + order.id + "/sendorder")
                                    .then((res) => {
                                      toast.success("Resended", {
                                        position: "bottom-right",
                                        autoClose: 2000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                      });
                                    })
                                    .catch((e) => {
                                      swal({
                                        title: "Oops!",
                                        text: "Something went wrong.",
                                        icon: "error",
                                      });
                                    });
                                }}
                              >
                                <Send />
                              </IconButton>
                            </Tooltip>
                          }
                        />
                        <AuthorizationWrapper
                          permission={"takeaway.refund"}
                          child={
                            <Tooltip title={"Refund"}>
                              <IconButton
                                onClick={() => {
                                  openDialog({
                                    children: (
                                      <RefundDialog
                                        amount={Math.round(order.cost * 100 - order.amount_refunded)}
                                        taMerchantId={taMerchantId}
                                        taReceiptId={order.id}
                                      />
                                    ),
                                  });
                                }}
                              >
                                <Payment />
                              </IconButton>
                            </Tooltip>
                          }
                        />
                        {order.amount_refunded > 0 ? (
                          <Typography style={{ color: "red" }}>
                            Amount refunded: {GetCurrency()} {(order.amount_refunded / 100.0).toFixed(2)}
                          </Typography>
                        ) : null}
                      </div>
                    </Grid>
                    <Grid item container lg={6} md={6} sm={12} xs={12}>
                      <div
                        className={classes.div}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "inherit",
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Typography style={{ flexBasis: "35%", fontWeight: "bold" }} variant="caption">
                            Naam
                          </Typography>
                          <Typography style={{ flexBasis: "25%", fontWeight: "bold" }} variant="caption">
                            Prijs per stuk
                          </Typography>
                          <Typography style={{ flexBasis: "15%", fontWeight: "bold" }} variant="caption">
                            Hoeveelheid
                          </Typography>
                          <Typography style={{ flexBasis: "25%", fontWeight: "bold" }} variant="caption">
                            Totaal
                          </Typography>
                        </div>
                        <Divider />
                        {order.orders.map((item) => {
                          return (
                            <div>
                              {item.name === "Bezorgkosten" || item.name === "Betaalkosten" ? <br /> : null}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Typography style={{ flexBasis: "35%" }} variant="caption">
                                  {item.name} {item.remark}
                                </Typography>
                                <Typography style={{ flexBasis: "25%" }} variant="caption">
                                  {GetCurrency()} {(item.cost / 100).toFixed(2)}
                                </Typography>
                                <Typography style={{ flexBasis: "15%" }} variant="caption">
                                  {item.amount}
                                  {item.amount === "" ? "" : "x"}
                                </Typography>
                                <Typography style={{ flexBasis: "25%" }} variant="caption">
                                  {GetCurrency()}{" "}
                                  {item.amount === ""
                                    ? (item.cost / 100).toFixed(2)
                                    : (item.totalCost / 100).toFixed(2)}
                                </Typography>
                              </div>
                              <div>
                                {item.modifiers
                                  ? item.modifiers.map((modifier) => {
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            marginTop: "0px",
                                          }}
                                        >
                                          <Typography
                                            style={{
                                              flexBasis: "35%",
                                              fontSize: "80%",
                                              color: "grey",
                                            }}
                                            variant="caption"
                                          >
                                            {" "}
                                            > {modifier.name}
                                          </Typography>
                                          <Typography
                                            style={{
                                              flexBasis: "25%",
                                              fontSize: "80%",
                                              color: "grey",
                                            }}
                                            variant="caption"
                                          >
                                            {modifier.cost === 0
                                              ? ""
                                              : "+" + GetCurrency() + " " + (modifier.cost / 100).toFixed(2)}
                                          </Typography>
                                        </div>
                                      );
                                    })
                                  : null}
                              </div>
                            </div>
                          );
                        })}
                        {order.tipAmount > 0 && (
                          <div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <Typography style={{ flexBasis: "35%" }} variant="caption">
                                Tipped:
                              </Typography>
                              <Typography style={{ flexBasis: "25%" }} variant="caption">
                                {GetCurrency()} {order.tipAmount.toFixed(2)}
                              </Typography>
                              <Typography style={{ flexBasis: "15%" }} variant="caption"></Typography>
                              <Typography style={{ flexBasis: "25%" }} variant="caption">
                                {GetCurrency()} {order.tipAmount.toFixed(2)}
                              </Typography>
                            </div>
                          </div>
                        )}
                        <Divider variant="light" />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography style={{ flexBasis: "75%" }}>Totaal</Typography>
                          <Typography style={{ flexBasis: "25%" }}>
                            {GetCurrency()} {order.cost.toFixed(2)}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}
      </div>

      <div>
        <Paper variant="outlined" style={{ height: "4em" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justify: "space-around",
            }}
          >
            <div
              style={{
                margin: "0 auto",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Typography style={{ marginTop: "15px", marginRight: "40px" }}>Page: {page + 1}</Typography>
              <Typography style={{ marginTop: "15px", marginRight: "10px" }}>Items per page: </Typography>
              <Select
                onChange={handleItemsPerPage}
                value={perPage}
                variant="outlined"
                style={{
                  height: "2em",
                  marginTop: "12px",
                  marginRight: "10px",
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>

              <IconButton onClick={fetchPreviousPage} style={{ marginTop: "5px" }}>
                <ChevronLeft />
              </IconButton>
              <IconButton onClick={fetchNextPage} style={{ marginTop: "5px" }}>
                <ChevronRight />
              </IconButton>
            </div>
          </div>
        </Paper>
      </div>
    </div>
  );
}

export default withIntl(TakeawayDeliveryOrders);
